<template>
  <div class="registration-page">
    <AppNavbar >
      <a href="#" @click.prevent="$router.back()">Go back</a>
    </AppNavbar>
    <main class="registration-content">
      <div class="container">
        <h1>Unlock the power of inboxmaster.ai</h1>
        <div class="registration-layout">
          <AboutFeatures />
          <div class="divider"></div>
          <div class="sign-in-section">
            <div class="sign-in-content">
              <h2 style="font-weight: 100; font-size: 24px;">Sign up here:</h2>
              <GoogleRegistrationButton :planType="selectedPlanName" :address="address" />
            </div>
          </div>
        </div>
      </div>
    </main>
    <AppFooter />
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import AppNavbar from '@/components/AppNavbar.vue';
import AppFooter from '@/components/AppFooter.vue';
import AboutFeatures from '@/components/AboutFeatures.vue';
import GoogleRegistrationButton from '@/components/GoogleRegistrationButton.vue';

export default defineComponent({
  name: 'RegistrationPage',
  components: {
    AppNavbar,
    AppFooter,
    AboutFeatures,
    GoogleRegistrationButton
  },
  data() {
    return {
      selectedPlanName: null,
      address: null
    };
  },
  created() {
    this.selectedPlanName = this.$route.query.plan || null;
    this.address = this.$route.query.address || null;
  }
});
</script>

<style scoped>
.registration-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.registration-content {
  flex: 1;
  padding-top: 100px; /* Space for fixed navbar */
  padding-bottom: 40px;
}

.container {
  width: 90%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.registration-layout {
  display: flex;
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 0;
  gap: 40px;
  align-items: flex-start;
}

.divider {
  width: 1px;
  background-color: #e0e0e0;
  align-self: stretch;
  margin: 20px 0;
}

.scopes-section {
  flex: 1;
  padding: 20px 0;
}

.scopes-section h3 {
  font-weight: 100;
  font-size: 20px;
  margin-bottom: 16px;
  color: #333;
}

.scopes-placeholder {
  background-color: #f5f5f5;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
}

.scope-note {
  margin-top: 12px;
  font-size: 14px;
  color: #666;
  font-style: italic;
}

.sign-in-section {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 20px;
}

h1 {
  text-align: center;
  margin-bottom: 40px;
  font-size: 36px;
  color: black;
  font-weight: 100;
}

@media (max-width: 768px) {
  .registration-content {
    padding-top: 0;
    padding-bottom: 20px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    min-height: calc(100vh - 80px);
  }
  
  .container {
    padding: 10px 15px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    flex: 1;
    margin-top: 20px;
  }
  
  h1 {
    font-size: 28px;
    margin-bottom: 10px;
    line-height: 1.2;
  }
  
  .registration-layout {
    flex-direction: column;
    gap: 15px;
    max-width: 100%;
    justify-content: flex-start;
    align-items: center;
  }
  
  .divider {
    display: none;
  }

  .scopes-section {
    padding: 0;
    order: 1;
  }
  
  .sign-in-section {
    padding-top: 0;
    justify-content: center;
    align-items: center;
    order: 2;
    width: 100%;
  }
  
  .sign-in-content {
    text-align: center;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  
  .sign-in-content h2 {
    font-size: 20px !important;
    margin-bottom: 15px;
  }
}

@media (max-width: 480px) {
  h1 {
    font-size: 24px;
    margin-bottom: 15px;
  }
  
  .sign-in-content h2 {
    font-size: 18px !important;
    margin-bottom: 12px;
  }
}
</style> 